const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/CardNavigationLink.tsx';
import * as React from 'react';
import { Typography } from '@mui/material';
import { css } from '@emotion/css';
import { IconMore } from 'App/components/Buttons/IconMore';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';

const cardNavigationLinkClass = css`
    display: flex;
    flex-direction: row;
    gap: 8px;
    cursor: pointer;

    > *:first-child {
        flex: auto;
    }

    > *:last-child {
        flex: none;
    }
`;

type Props = {
    text: TextInput;
};

export const CardNavigationLink = (props: Props): any => {
    const text = useText(props.text);

    return (
        <div className={cardNavigationLinkClass}>
            <Typography variant="subtitle1" component="h2" sx={{ color: 'primary.main' }}>
                {text}
            </Typography>
            <IconMore />
        </div>
    );
};
